<template>
<div class="chapter">
<div class="inner_page">
<p class="dedt" id="pageii"><em class="italic">For Squadron Leader Brian Lane DFC and all my departed personal friends who served on 19 Squadron 1938-1941.</em></p>
<p class="ded">© Dilip Sarkar, 2018</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?3b350986